import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { companyInfo } from '../mock';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-background"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-accent-teal/10 border border-accent-teal/30 rounded-full px-4 py-2 mb-6 mt-8 fade-in">
            <Sparkles size={16} className="text-accent-teal" />
            <span className="text-sm font-medium text-accent-teal">Digital Innovation Studio</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 fade-in" style={{ animationDelay: '0.1s' }}>
            {companyInfo.tagline}
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-neutral-silver mb-10 fade-in" style={{ animationDelay: '0.2s' }}>
            We specialize in <span className="text-accent-teal font-semibold">Website Development</span>, <span className="text-accent-violet font-semibold">Web Applications</span>, and <span className="text-accent-teal font-semibold">Game Development</span> that transform your vision into reality.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 fade-in" style={{ animationDelay: '0.3s' }}>
            <a href="#contact" className="btn-primary">
              Get Started
              <ArrowRight size={20} />
            </a>
            <a href="#projects" className="btn-secondary">
              View Our Work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
